// @ts-nocheck
import router from '../router';
import store from '../store';
// import { Message } from 'element-ui'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '../utils/token';
import { getRolePermitAccountApi, getUserOperationApi } from '../api/user';
import { filterMenu } from '@/filters/index.js';
const whiteList = [
  '/login',
  '/privacyPolicy',
  '/serviceAgreement',
  '/jumpToApp',
];
router.beforeEach(async (to, from, next) => {
  // console.log(to.path,from,"路由经过和到达")
  NProgress.start();
  const hasToken = getToken();
  if (hasToken) {
    //   to.path == '/choose' ||
    //   to.path == '/login' ||
    //   to.path == '/privacyPolicy'
    if (
      [
        '/choose',
        '/login',
        '/privacyPolicy',
        '/serviceAgreement',
        '/jumpToApp',
      ].includes(to.path)
    ) {
      next();
      NProgress.done();
    } else {
      let roleList = store.getters.roleList;
      // let operationList = store.getters.operationList
      // 有权限列表
      if (roleList) {
        next();
        NProgress.done();
      } else {
        // console.log("无权限")
        const res = await getUserOperationApi();
        if (res.code === 200) {
          let data = res.data.operationDtos.map((child) => child.operationCode);
          store.dispatch('role/setOperationList', data);
        }
        const userInfo = JSON.parse(getToken('userInfo'));
        getRolePermitAccountApi({
          houseId: userInfo.houseId,
        }).then((res) => {
          if (res.code === 200) {
            let resData = [...res.data];
            let realMenu = [];
            let obj = {};
            for (let i = 0; i < resData.length; i++) {
              let item = resData[i];
              const menuChild = resData.find(
                (child) => child.menu.superId.trim() == item.menu.menuId
              );
              if (
                (menuChild ||
                  JSON.stringify(item.permits).indexOf('_Catalogue') != -1) &&
                item.permits
              ) {
                realMenu.push(item);
              } //返回父节点或有目录权限的子菜单
              obj[item.menu.url] = item.permits
                ? item.permits.map((child) => child.code)
                : [];
            }
            // console.log(realMenu,"lalala")
            let array1 = filterMenu(realMenu); //过滤为父子形式
            // const routerObj = [{
            //     path: "/home",
            //     component: () => import('@/views/home/index'),
            //     name: 'Home',
            //     redirect:"/home/chart",
            //     meta: {
            //         roles: ['系统角色', '中介经济人', '普通员工', '内部员工' ]
            //     },
            //     children:array1
            // }]
            // router.addRoutes(routerObj)
            // console.log(obj, "总权限")
            // let array = filterRouter(array1) //过滤为路由
            store.dispatch('role/setRoleList', obj); //存储权限
            store.dispatch('role/setMenuList', array1); //存储菜单
            // console.log("执行了此函数")

            next();
            NProgress.done();
          }
        });
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // console.log("无token")
      next();
      NProgress.done();
    } else {
      next('/login');
      NProgress.done();
    }
  }
});
